/**
 * @file CustomerMarks.tsx
 * @description Пометки клиента пилюлями (phase19.31): «Блок: заказы»
 * (красный), «Риск 70» (янтарный), «Анонимизирован» / «Неактивен» (серый).
 * Набор и тона — `customerMarks` (lib/crm-customer-view); нет пометок —
 * прочерк или ничего (`emptyDash`).
 */

import { StatusPill } from "../ui/StatusPill";
import type { CustomerDto } from "../../lib/api-customers";
import { customerMarks } from "../../lib/crm-customer-view";

interface Props {
  customer: Pick<CustomerDto, "blockedScopes" | "riskScore" | "anonymizedAt" | "isActive">;
  /** Без пометок показать «—» (ячейка таблицы); иначе — ничего. */
  emptyDash?: boolean;
}

export function CustomerMarks({ customer, emptyDash = false }: Props) {
  const marks = customerMarks(customer);
  if (marks.length === 0) return emptyDash ? <span className="text-on-surface-variant">—</span> : null;
  return (
    <span className="flex min-w-0 flex-wrap items-center gap-1">
      {marks.map((m) => (
        <StatusPill key={m.key} tone={m.tone}>
          {m.label}
        </StatusPill>
      ))}
    </span>
  );
}
